module.exports = __webpack_public_path__ + "img/ocean-kids.41f35af9.jpg";